import { TemplateRef } from '@angular/core';
import { CustomEventModel } from '@models/custom-event.model';
import {
  CellTemplateContext,
  ColumnBuilder,
  DatasetTableConfig,
  TableConfigBuilder,
  deleteAction,
} from '@ui/lib/ui-kit/ui-dataset-table';

export type CreateEventTagFieldCellContext = CellTemplateContext<CustomEventModel.CustomEventField>;

export interface CreateEventTagResultTableConfigDependencies {
  nameCellTemplate: TemplateRef<CreateEventTagFieldCellContext>;
  typeCellTemplate: TemplateRef<CreateEventTagFieldCellContext>;
}

/**
 * Twin of the Database → Event tags editor's field table: an editable name cell,
 * an editable type cell and a delete action.
 *
 * No `trackBy` — a field has no id, so rows are index-tracked, and re-keying a
 * row while it is being typed into would tear down its focused input.
 */
export function createEventTagResultTableConfig(
  dependencies: CreateEventTagResultTableConfigDependencies,
): DatasetTableConfig<CustomEventModel.CustomEventField> {
  const builder = new ColumnBuilder<CustomEventModel.CustomEventField>();

  return new TableConfigBuilder<CustomEventModel.CustomEventField>()
    .columns([
      builder
        .column('name')
        .label('EDIT_CUSTOM_EVENT.TABLE.NAME')
        .width('minmax(100px, 1fr)')
        .cellTemplate(dependencies.nameCellTemplate)
        .mobileVisible()
        .cardMode('label-only')
        .build(),

      builder
        .column('type')
        .label('EDIT_CUSTOM_EVENT.TABLE.TYPE')
        .width('minmax(100px, 0.7fr)')
        .cellTemplate(dependencies.typeCellTemplate)
        .mobileVisible()
        .cardMode('label-only')
        .build(),
    ])
    .actions([deleteAction<CustomEventModel.CustomEventField>()])
    .build();
}
